<InactivityModal />
<div class="container-fluid h-100">
    <div class="row h-100 ">
      <div class="col-auto bg-white h-100">
        <Sidebar ref="sidebar"></Sidebar>
      </div>
      <div class="col bg-white h-100 m-0">
        <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
        <div class="bg-gray px-4 py-1 h-100 scroll-container">
   <!-- Forms Management -->
   <div class="card bg-white shadow-sm mt-5 rounded-5 border-0">
    <div class="card-header bg-white border-0 rounded-5">
        <span class="fw-500">Forms</span> <br>
        <button class="btn btn-sm btn-secondary text-white text-xxs rounded-3 shadow-lg fw-500"
            data-bs-toggle="modal" data-bs-target="#create_form">
            <i class='bx bx-plus'></i> Add Form
        </button>
    </div>
    <div class="card-body table-responsive">
        <table class="table table-striped text-xxs mt-3">
            <thead class="bg-dark text-white">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Form Name</th>
                    <th scope="col">Description</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody class="text-black">
                <tr v-for="(form, index) in forms" :key="form.id">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ form.name }}</td>
                    <td>{{ form.description }}</td>
                    <td>
                        <router-link :to="'/create_section/' + form.id">

                            <button class="btn btn-primary text-xxs rounded-5 mx-1 btn-sm shadow">
                              <i class="bi bi-pencil-square"></i> Manage form
                            </button>
                            </router-link>
                            <button type="button" class="btn btn-primary text-xxs rounded-5 mx-1 btn-sm shadow" data-bs-toggle="modal"
          data-bs-target="#assignQuestionsModal" @click="prepareAssignQuestions(form.id)">Assign Questions</button>

                        <button
                          class="btn btn-danger text-xxs rounded-5 mx-1 btn-sm shadow"
                          @click="delete_form(form.id)">
                          <i class="bi bi-trash"></i> Delete
                      </button>
                      </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
        </div>

     
       </div>
      </div> 
       

        <!-- Modal for Creating Form -->
        <div class="modal fade" id="create_form" tabindex="-1" aria-labelledby="createFormLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title text-xs fw-500">Create Form</p>
                        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <form @submit.prevent="createForm">
                        <div class="modal-body">
                            <div class="mb-3">
                                <label for="form_name" class="form-label text-xs fw-500">
                                    Form Name <span class="text-danger">*</span>
                                </label>
                                <input type="text" class="form-control rounded-5 text-xs" id="form_name"
                                    v-model="form_name" placeholder="Enter form name">
                                <p v-if="errors.form_name" class="text-danger text-xs">{{ errors.form_name }}</p>
                            </div>

                            <div class="mb-3">
                                <label for="form_description" class="form-label text-xs fw-500">Description</label>
                                <textarea class="form-control rounded-5 text-xs" id="form_description"
                                    v-model="form_description" placeholder="Enter description"></textarea>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary text-xs rounded-5">Create Form</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>


        <div class="modal fade" id="assignQuestionsModal" tabindex="-1" aria-labelledby="assignQuestionsModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 v-if="is_unassigning" class="modal-title text-xs fw-500" id="assignQuestionsModalLabel">
                  Unassign Questions
                </h5>
                <h5 v-else class="modal-title text-xs fw-500" id="assignQuestionsModalLabel">
                  Assign Questions
                </h5>
                <button
                  type="button"
                  class="btn-close text-xs fw-500"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <p class="text-xs">Select the profile types to assign the selected questions:</p>
        
                <div
                  class="form-check form-check-sm text-xs"
                  v-for="profile in profile_types"
                  :key="profile.id"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'profile_' + profile.id"
                    :value="profile.id"
                    v-model="selected_profiles"
                  />
                  <label
                    class="form-check-label text-xs"
                    :for="'profile_' + profile.id"
                  >
                    {{ profile.name }}
                  </label>
        
                </div>
              </div>
        
              <div class="modal-footer">
                <button
                  v-if="is_unassigning"
                  type="button"
                  class="btn btn-primary text-xs rounded-5"
                  @click="filter_assigned_questions"
                >
                  Continue
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-primary text-xs rounded-5"
                  @click="assignQuestions"
                >
                  Assign
                </button>
              </div>
            </div>
          </div>
        </div>
        
</div>
